import { render, staticRenderFns } from "./favicon.vue?vue&type=template&id=e478b0b2"
import script from "./favicon.vue?vue&type=script&lang=js"
export * from "./favicon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports